export default __webpack_public_path__ + "static/media/projectFurniture.fcea9d87.bin";